import React, { useMemo, useState } from "react";
import RecipeIngredients from "components/recipe/RecipeIngredients";
import RecipeKitchenTools from "components/recipe/RecipeKitchenTools";
import BaseButton from "base/BaseButton";

const RecipeIngredientToolTab = ({ recipe, servings }) => {
  const [ingredientKitchenToolTab, setIngredientKitchenToolTab] =
    useState(true);
  const [areIngredientsSorted, setAreIngredientsSorted] = useState(false);
  const [areKitchenToolsSorted, setAreKitchenToolsSorted] = useState(false);

  const handleIngredientKitchenToolTabClick = () => {
    setIngredientKitchenToolTab((current) => !current);
  };

  // const itemNeeded = (e) => {
  //   props.itemNeeded(e.target.textContent);
  // };

  const displayIngredients = useMemo(() => {
    const ingredients = recipe?.ingredients || [];
    if (!areIngredientsSorted) {
      return ingredients;
    }
    return [...ingredients].sort((a, b) =>
      (a?.name || "").localeCompare(b?.name || ""),
    );
  }, [recipe?.ingredients, areIngredientsSorted]);

  const displayKitchenTools = useMemo(() => {
    const kitchenTools = recipe?.kitchen_tools || [];
    if (!areKitchenToolsSorted) {
      return kitchenTools;
    }
    return [...kitchenTools].sort((a, b) =>
      (a?.name || "").localeCompare(b?.name || ""),
    );
  }, [recipe?.kitchen_tools, areKitchenToolsSorted]);

  return (
    <section className="p1">
      <div className="Row Space-B">
        <h4
          className={ingredientKitchenToolTab ? "Selected" : "Not-Selected"}
          onClick={handleIngredientKitchenToolTabClick}
        >
          Ingredients
        </h4>
        <h4
          className={ingredientKitchenToolTab ? "Not-Selected" : "Selected"}
          onClick={handleIngredientKitchenToolTabClick}
        >
          Kitchen Tools
        </h4>
      </div>
      {ingredientKitchenToolTab ? (
        <div className="marg-t-1">
          <div className="Justify-Center">
            <BaseButton
              buttonText="ABC"
              className="Green p-1 bord-5 Background-LGreen"
              onClick={() => setAreIngredientsSorted((current) => !current)}
              widthClass="w-30"
            />
          </div>
          {displayIngredients.map((ingredient, index) => (
            <RecipeIngredients key={ingredient?.id ?? `${ingredient?.name || "ingredient"}-${index}`}
              ingredient={ingredient}
              servings={servings}
              originalServings={recipe?.num_of_servings}
            />
          ))}
          {/* <a
              onClick={itemNeeded}
              className="Row marg-1 Justify-Center Green"
              value="ingredient"
            >
              <h6 className="Small-Font">I need an Ingredient</h6>
            </a> */}
        </div>
      ) : (
        <div className="marg-t-1">
          <div className="Justify-Center">
            <BaseButton
              buttonText="ABC"
              handleClick={() =>
                setAreKitchenToolsSorted((current) => !current)
              }
              widthClass="w-30"
            />
          </div>
          {displayKitchenTools?.map((kitchenTool, index) => (
            <RecipeKitchenTools
              index={index}
              key={kitchenTool?.id ?? `${kitchenTool?.name || "tool"}-${index}`}
              kitchenTool={kitchenTool}
            />
          ))}
          {/* <a onClick={itemNeeded} className="Row marg-1 Justify-Center Green">
              <h6 className="Small-Font">I need a Kitchen Tool</h6>
            </a> */}
        </div>
      )}
    </section>
  );
};

export default RecipeIngredientToolTab;
